<template lang="pug">
  .t-container
    .timeline(:class="{ verticalDirection: vertical }")
      .circle-cont(v-for="(item, index) in nodes")
        .selected(:class="{ visible: selected === index + 1 }")
        .circle(:style="`background: ${colorNodes(index)};`" @click="selectStage(item, index)" @dblclick="counter++, navigateTo(item, index)")
          vm-icon(:icon="item.icon" v-if="!!item.icon" color="white" size="1.5rem")
        .title(:class="{ bold: selected === index + 1 }") {{ item.name }}
      .progress-bar-cont
        .progress-bar
          .progress-fill(:style="`width: ${progress}%;`")
</template>

<script>
export default {
  name: 'HorizontalTimeLine',
  props: {
    nodes: {
      type: Array,
      default: () => [{ name: 'Node 1' }, { name: 'Node 2' }, { name: 'Node 3' }]
    },
    baseColor: {
      type: String,
      default: '#808080'
    },
    primaryColor: {
      type: String,
      default: '#3498db'
    },
    successColor: {
      type: String,
      default: '#17C964'
    },
    warningColor: {
      type: String,
      default: '#ff8200'
    },
    errorColor: {
      type: String,
      default: '#ED1C24'
    },
    vertical: {
      type: Boolean,
      default: false
    },
    progress: {
      type: Number,
      default: 0
    },
    stage: {
      type: Number,
      default: -1
    },
    selected: {
      type: Number
    },
    rfi: {
      type: Array
    },
    quotation: {
      type: Object
    }
  },
  data: () => ({
    isClickable: false,
    counter: 0
  }),
  methods: {
    colorNodes (index) {
      if (index === 0 && parseInt(this.stage) === index + 1) {
        return this.primaryColor
      } else if (index === 1 && parseInt(this.stage) === 2) {
        if (!!this.quotation && !!this.quotation.status) {
          if (parseInt(this.quotation.status) === 1 || parseInt(this.quotation.status) === 2) {
            return this.warningColor
          }
          if (parseInt(this.quotation.status) === 4 || parseInt(this.quotation.status) === 5) {
            return this.dangerColor
          }
        }
        if (this.rfi.filter(e => e.quotation_id && !e.answer).length > 0) {
          return this.warningColor
        }
        return this.primaryColor
      } else if (index === 2 && parseInt(this.stage) === 3) {
        if (this.rfi.filter(e => e.project_id && !e.answer).length > 0) {
          return this.warningColor
        }
        return this.primaryColor
      } else if (index === 3 && parseInt(this.stage) === 4) {
        return this.primaryColor
      }
      if (parseInt(this.stage) > index + 1) {
        return this.successColor
      }
    },
    selectStage (item, index) {
      if (parseInt(this.stage) >= index + 1) {
        this.$emit('selected', index + 1)
      }
    },
    navigateTo (item, index) {
      if (parseInt(this.stage) >= index + 1 && item.url !== '') {
        this.$router.push(`${item.url}${this.$route.params.id}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$width: 50px;
.t-container {
  width: 100%;
  position: relative;
  user-select: none;
}
.circle {
  background: rgb(212, 212, 212);
  border: 2px solid white;
  box-sizing: content-box;
  width: $width;
  height: $width;
  border-radius: 50%;
  margin: 0 auto;
  -webkit-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.33);
  -moz-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.33);
  box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.33);
  display: flex;
  align-items: center;
  justify-content: center;
}
.circle-cont {
  text-align: center;
  z-index: 2;
  cursor: pointer;
}
.verticalDirection {
  flex-direction: column;
}
.timeline {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.progress-bar-cont {
  width: 100%;
  position: absolute;
  height: 2px;
  top: 42%;
  padding: 0 30px;
  z-index: 1;
}
.progress-bar {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  background: rgb(212, 212, 212);
}
.progress-fill {
  height: 100%;
  border-radius: 5px;
  background: #17C964;
  background-image: linear-gradient(100deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 80%),
    linear-gradient(#17C964 25px, transparent 0),
    linear-gradient(#17C964 25px, transparent 0),
    linear-gradient(#17C964 25px, transparent 0),
    linear-gradient(#17C964 25px, transparent 0),
    linear-gradient(#17C964 25px, transparent 0);

  background-repeat: repeat-y;
  background-size: 55px 50px, 70px 60px, 100px 60px, 150px 60px, 80px 60px, 100px 60px;
  background-position: 0 0, 20px 0, 120px 0, 210px 0, 390px 0, 500px 0;
  animation: shine 1s infinite;
}
@keyframes shine {
  to {
    background-position:
      100% 0,
      20px 0,
      120px 0,
      210px 0,
      390px 0,
      500px 0;
  }
}
.title {
  margin-top: 10px;
}
.bold {
  font-weight: bold;
}
.selected {
  border-radius: 50%;
  height: 5px;
  width: 5px;
  background: gray;
  margin: 0 auto 10px auto;
  opacity: 0;
}
.visible {
  opacity: 1;
}
</style>
